import { axios } from "../../lib/axios";

export interface IfrsQuestions {
  text: string;
  exhibits?: {
    title: string;
    type: string;
    filePath: string;
  }[];
  requirements: string;
  responseOptions: {
    wordProcessor: boolean;
    spreadsheet: boolean;
    spreadsheetFilePath?: string;
  };
}

export interface IFRSDTO {
  title: string;
  duration: string;
  answer: string;
  lectureId: string;
  OpenLectureId: string;
  chapterId: string;
  ifrsQuestions: IfrsQuestions[];
}

export const CreateIFRS = (data: IFRSDTO): Promise<IFRSDTO> => {
    return axios.post("/ifrs/create", data)
        .then(response => response.data as IFRSDTO);
};
